import { render, staticRenderFns } from "./CardBySide1.vue?vue&type=template&id=006dd8dd&scoped=true&"
import script from "./CardBySide1.vue?vue&type=script&lang=js&"
export * from "./CardBySide1.vue?vue&type=script&lang=js&"
import style0 from "./CardBySide1.vue?vue&type=style&index=0&id=006dd8dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006dd8dd",
  null
  
)

export default component.exports